import React, {
  createContext,
  ReactNode,
  useContext,
  useState,
} from "react";
import { useMutation } from '@tanstack/react-query'
import { apiModulo } from '../services/api'
import { BoletoData, TCDResponse } from "../types/emitir-boleto-interface";
import { useModal } from "../hooks/ModalContext";
import { AxiosError } from "axios";

interface BoletoContextProviderProps {
  children: ReactNode;
}

interface RequestBoleto {
  url: string;
  contrato: string;
  cpf_cnpj: string;
  codcredor: string;
  idproposta?: string;
  modo: string;
  canalrecebimento: string;
  destinorecebimento: string;
  vencimento?: string;
  nossonumero?: string;
  formapagamento?: string;
  id?: string
  app: string
  usuario?: string;
}


interface BoletoContextProps {
  enviarBoleto(dataRequest: RequestBoleto, usuario?: string): Promise<void>
  generateTDC(dataRequest: RequestBoleto, usuario: string): Promise<void>
  emitirBoleto(dataRequest: RequestBoleto): Promise<void>
  getErroBoletoFalse(): void
  clearBoleto(): void
  boleto: BoletoData
  erroBoleto: boolean
  tdcResponse: TCDResponse
  requestBoleto: RequestBoleto
}

const BoletoContext = createContext<BoletoContextProps>({} as BoletoContextProps);

export const BoletoProvider = ({ children }: BoletoContextProviderProps) => {
  const [boleto, setBoleto] = useState<BoletoData>({} as BoletoData)
  const [requestBoleto, setRequestBoleto] = useState({} as RequestBoleto)
  const [erroBoleto, setErroBoleto] = useState(false)
  const [tdcResponse, setTCDResponse] = useState<TCDResponse>({} as TCDResponse)
  // const [gerarBoletoSucesso, setGerarBoletoSucesso] = useState(false)
  const { setModal } = useModal()


  const mGerarBoleto = useMutation({
    mutationFn: (data: RequestBoleto) => apiModulo.post('ticket/generate ', { ...data, }),
    mutationKey: ['form'],
    // onError: () => setModal('Ops! Ocorreu um erro em nosso sistema. Tente novamente mais tarde!', 'Erro', false, true)
    onError: (error: AxiosError) => {
      const data = error?.response?.data as { message: string }
      setModal(data.message, 'Erro', false, true)
    },
  })

  const mEmitirBoleto = useMutation({
    mutationFn: (data: RequestBoleto) => apiModulo.post('ticket/send ', { ...data, }),
    mutationKey: ['form'],
    // onError: () => setModal('Ops! Ocorreu um erro em nosso sistema. Tente novamente mais tarde!', 'Erro', false, true)
    onError: () => setModal('Erro Emitir Boleto', 'Erro', false, true)
  })

  const mGenerateTDC = useMutation({
    mutationFn: (data: RequestBoleto) => apiModulo.post('ticket/tcd ', { ...data }),
    mutationKey: ['form'],
    onError: () => setModal('Ops! Ocorreu um erro em nosso sistema. Tente novamente mais tarde!', 'Erro', false, true)
  })

  function clearBoleto() {
    setBoleto({} as BoletoData)
    setTCDResponse({} as TCDResponse)
  }

  async function enviarBoleto(dataRequest: RequestBoleto, usuario: string) {
    let dataRequestGerar = {
      ...dataRequest,
      usuario,
    }

    if (dataRequest.formapagamento === '5') {
      dataRequestGerar = {
        ...dataRequestGerar,
        canalrecebimento: '',
        destinorecebimento: '',
      }
    }

    const { data } = await mGerarBoleto.mutateAsync(dataRequestGerar)
    const dataEmitir = {
      ...dataRequestGerar,
      vencimento: '',
      nossonumero: data.message.boleto.nossonumero,
      // id: data.message.boleto.nossonumero
    }

    if (dataRequestGerar.nossonumero === '') {
      setErroBoleto(true)
      return
    }

    setRequestBoleto(dataEmitir)
    // setRequestBoleto({ ...dataEmitir, nossonumero: data.message.boleto.nossonumero, })

    const { data: dataResponse } = await mEmitirBoleto.mutateAsync(dataEmitir)
    const dataBoleto = { url: dataResponse.message.boletos[0].url, dadoboleto: dataResponse.message.boletos, }
    setRequestBoleto({} as RequestBoleto)

    if (dataRequest.formapagamento === '5') {
      const boleto = {
        dadoboleto: [
          {
            linhaDigitavel: 'Acordo com Pgto em loja'
          }
        ],
        url: 'Acordo com Pgto em loja'
      }

      setBoleto(boleto)
      return
    }
    setBoleto(dataBoleto)
    return
  }

  async function emitirBoleto(dataRequest: RequestBoleto) {
    const { data: dataResponse } = await mEmitirBoleto.mutateAsync(dataRequest)
    const dataBoleto = { url: dataResponse.message.boletos[0].url, dadoboleto: dataResponse.message.boletos, }
    setRequestBoleto({} as RequestBoleto)


    if (dataRequest.formapagamento === '5') {
      console.log('Passou aqui com o formapagamento')
      const boleto = {
        dadoboleto: [
          {
            linhaDigitavel: 'Acordo com Pgto em loja'
          }
        ],
        url: 'Acordo com Pgto em loja'
      }
      setBoleto(boleto)
      return
    }

    setBoleto(dataBoleto)
    return
  }

  function getErroBoletoFalse() {
    setErroBoleto(false)
  }

  async function generateTDC(dataRequest: RequestBoleto, usuario: string) {
    const { data } = await mGenerateTDC.mutateAsync(dataRequest)
    setTCDResponse(data.message)
  }


  return (
    <BoletoContext.Provider value={{ enviarBoleto, boleto, erroBoleto, getErroBoletoFalse, clearBoleto, generateTDC, tdcResponse, requestBoleto, emitirBoleto }}>
      {children}
    </BoletoContext.Provider>
  );
};

export const useBoleto = () => useContext(BoletoContext);